import React, { FunctionComponent } from "react"
import { Controller, FormProvider, useForm } from "react-hook-form"

import { iExhibition } from "../../definitions/Exhibition"
import { handleCreateExhibition } from "../../store/data/actions"
import { Route, useHistory, useRouteMatch } from "react-router"
import ExhibitionOverview from "./inspector/Overview"
import ExhibitionUploads from "./inspector/Uploads"
import ExhibitionHeader from "./Header"
import { withPackage } from "../../components/withPackage/withPackage"
import ManageSpace from "./inspector/ManageSpace"
import ManageArtPieces from "./inspector/ManageArtPieces"
import ManageArtifacts from "./inspector/ManageArtifacts"
import ManageAssets from "./inspector/ManageAsssets"

const CreateExhibition: FunctionComponent = () => {
  const history = useHistory()
  const match = useRouteMatch()
  const onSubmit = (data: iExhibition) => {
    handleCreateExhibition(data).then((exhibition) => {
      history.push("/exhibitions/" + exhibition.url)
    })
  }

  const methods = useForm({ shouldUnregister: false })

  return (
    <FormProvider {...methods}>
      <ExhibitionHeader
        submitEditorText="Editor"
        submitVisitText="Visit"
        submitPublishText="Publish"
        submitDeleteText="Delete"
        title="Create Exhibition"
        submitText="Create"
        type="create"
        handleDelete={() => {
          console.log()
        }}
        handleSubmit={() => {
          methods.handleSubmit((data) => {
            onSubmit(data as iExhibition)
          })()
        }}
      />
      <div className={`inspector`}>
        <form
          className="inspector-form"
          onSubmit={methods.handleSubmit((data) => {
            onSubmit(data as iExhibition)
          })}
        >
          <Route exact path={match.path}>
            <ExhibitionOverview />
          </Route>
          <Route exact path={match.path + "/space"}>
            <Controller
              name="gallerySpaceId"
              control={methods.control}
              as={ManageSpace}
            />
          </Route>
          <Route exact path={match.path + "/manage-files"}>
            <ExhibitionUploads />
          </Route>
          <Route exact path={match.path + "/manage-artpieces"}>
            <Controller
              name="artPieces"
              control={methods.control}
              as={ManageArtPieces}
            />
          </Route>
          <Route exact path={match.path + "/manage-artifacts"}>
            <Controller
              name="artifacts"
              control={methods.control}
              as={ManageArtifacts}
            />
          </Route>
          <Route exact path={match.path + "/manage-assets"}>
            <Controller
              name="assets"
              control={methods.control}
              as={ManageAssets}
            />
          </Route>

          <button style={{ display: "none" }} type="submit">
            Submit
          </button>
        </form>
      </div>
    </FormProvider>
  )
}

export default withPackage(CreateExhibition, "Exhibitions")
